/**
 * 事件相关枚举值
 */

// 事件来源
export const EVENT_SOURCE = {
  PUBLIC: 'public',
  STAFF: 'staff',
  DRONE: 'drone',
  CAR: 'car'
}

// 事件来源中文名称
export const EVENT_SOURCE_LABEL = {
  [EVENT_SOURCE.PUBLIC]: '公众上报',
  [EVENT_SOURCE.STAFF]: '人员巡检',
  [EVENT_SOURCE.DRONE]: '无人机巡检',
  [EVENT_SOURCE.CAR]: '巡检车巡检'
}

// 事件类别
export const EVENT_CATEGORY = {
  GARBAGE: 'garbage',
  ROAD: 'road',
  PARKING: 'parking',
  MANHOLE: 'manhole',
  LAWN: 'lawn'
}

// 事件类别中文名称
export const EVENT_CATEGORY_LABEL = {
  [EVENT_CATEGORY.GARBAGE]: '垃圾堆放',
  [EVENT_CATEGORY.ROAD]: '道路损坏',
  [EVENT_CATEGORY.PARKING]: '泊车问题',
  [EVENT_CATEGORY.MANHOLE]: '井盖问题',
  [EVENT_CATEGORY.LAWN]: '草坪维护'
}

// 事件状态
export const EVENT_STATUS = {
  PENDING: 10,
  REVIEWING: 20,
  COMPLETED: 91,
  REJECTED: 92,
  CANCELED: 93
}

// 事件状态中文名称
export const EVENT_STATUS_LABEL = {
  [EVENT_STATUS.PENDING]: '待处理',
  [EVENT_STATUS.REVIEWING]: '待审核',
  [EVENT_STATUS.COMPLETED]: '已完成',
  [EVENT_STATUS.REJECTED]: '已打回',
  [EVENT_STATUS.CANCELED]: '已取消'
}

// 事件状态对应的颜色
export const EVENT_STATUS_COLOR = {
  [EVENT_STATUS.PENDING]: 'blue',
  [EVENT_STATUS.REVIEWING]: 'orange',
  [EVENT_STATUS.COMPLETED]: 'green',
  [EVENT_STATUS.REJECTED]: 'red',
  [EVENT_STATUS.CANCELED]: 'gray'
}

/**
 * 获取枚举值对应的标签
 * @param {Object} enumObj 枚举对象
 * @param {Object} labelObj 标签对象
 * @returns {Array} 包含 value 和 label 的数组
 */
export const getEnumOptions = (enumObj, labelObj) => {
  return Object.keys(enumObj).map(key => ({
    value: enumObj[key],
    label: labelObj[enumObj[key]]
  }))
}

// 导出所有选项数组，方便直接使用
export const EVENT_SOURCE_OPTIONS = getEnumOptions(EVENT_SOURCE, EVENT_SOURCE_LABEL)
export const EVENT_CATEGORY_OPTIONS = getEnumOptions(EVENT_CATEGORY, EVENT_CATEGORY_LABEL)
export const EVENT_STATUS_OPTIONS = getEnumOptions(EVENT_STATUS, EVENT_STATUS_LABEL) 